// apps/web/src/layouts/Protected.tsx
import { useEffect } from 'react'
import { Outlet, useRouteLoaderData } from 'react-router-dom'

import Footer from '@/components/account/Footer'
import Sidebar from '@/components/account/Sidebar'
import SidebarControls from '@/components/account/SidebarControls'
import { useLocation } from 'react-router-dom'
import Topbar from '@/components/account/TopBar'
import TranslateWarning from '@/components/TranslateWarning'
import DisableClearOnSubmitted from '@/components/DisableClearOnSubmitted'
import { useAutosave } from '@/hooks/useAutosave'
import { useUnsavedChangesWarning } from '@/hooks/useUnsavedChangesWarning'
import type { LoaderDataAccount } from '@/guards'
import { appStore, useAppStore } from '@/store/app'

export default function ProtectedLayout() {
	const data = useRouteLoaderData('account-root') as LoaderDataAccount | undefined
	const loaderUser = data?.user
	const { user: current } = useAppStore()
	const location = useLocation()
	const allowedMobileRoutes = new Set([
		'/account/steps/general',
		'/account/steps/background',
		'/account/steps/program',
		'/account/steps/aid',
	])

	// hydrate store if it’s empty (first mount after a hard refresh)
	useEffect(() => {
		if (!current && loaderUser) {
			appStore.init(loaderUser)
		}
	}, [current, loaderUser])

	useAutosave(30000)
	useUnsavedChangesWarning()

	if (!current && !loaderUser) return null

	return (
		<div className="flex min-h-dvh flex-col">
			<DisableClearOnSubmitted />
			<Topbar />
			<TranslateWarning />
			<section className="z-0 flex-1">
				<div className="relative mx-auto flex flex-wrap items-start px-4 sm:container lg:mt-4">
					<Sidebar />
					<div className="relative z-0 mx-auto w-full flex-1 pt-10 pb-24 md:max-w-4xl md:px-8 lg:pt-0 lg:pb-8">
						<Outlet />
						{allowedMobileRoutes.has(location.pathname) && (
							<div className="bg-background border-t py-4 lg:hidden">
								<SidebarControls isMobile />
							</div>
						)}
					</div>
				</div>
			</section>
			<Footer />
		</div>
	)
}
